const Save = ({ attributes }) => {
  const { cardTitle, buttonText, image, linkButton } = attributes

  return (
    <div className='CardContent'>
      <figure className='CardContent-image'>
        <img src={image.src} title={image.alt} width={image.width} height={image.height} alt={image.alt} class='MainFeatured-news-image' />
      </figure>

      <div className="CardContent-info">
        <h3 className="CardContent-title">{cardTitle}</h3>
        <a className="CardContent-button" href={linkButton} title={cardTitle}>{buttonText}</a>
      </div>
    </div>
  )
}

export default Save
